import PropTypes from 'prop-types';

export default {
  showDialog: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onStop: PropTypes.func.isRequired

};
